<template>
  <div>
    <Hero :title="`${$t('message.hero.helpUsVerify', { name: firstName })}`"></Hero>
    <EmphasizeBox class="mt-3 mb-4" :text="`${$t('message.credit.disclaimer.noAffectScoreVersion2')}`"></EmphasizeBox>
  </div>
</template>

<script>
import Hero from '../../Hero.vue';
import EmphasizeBox from '../../EmphasizeBox.vue';

export default {
  name: 'HelpUsVerify',
  components: {
    Hero,
    EmphasizeBox,
  },
  computed: {
    firstName() {
      return this.$store.state.user.firstName;
    },
  },
};
</script>

<style scoped>
.custom-mt {
  margin-top: 20px;
}
</style>
